import React from 'react';

type ClientMedium = 'online' | 'offline';

interface MediumFilterChipsProps {
  selectedMediums: Set<ClientMedium>;
  onToggleMedium: (medium: ClientMedium) => void;
  counts: Record<ClientMedium, number>;
}

const MEDIUM_OPTIONS: Array<{
  value: ClientMedium;
  label: string;
  unselectedStyle: string;
  selectedStyle: string;
}> = [
  {
    value: 'online',
    label: 'Online',
    unselectedStyle: 'bg-blue-100 text-blue-700 border border-blue-200',
    selectedStyle: 'bg-blue-200 text-blue-800 border-2 border-blue-400 shadow-sm',
  },
  {
    value: 'offline',
    label: 'Offline',
    unselectedStyle: 'bg-amber-100 text-amber-700 border border-amber-200',
    selectedStyle: 'bg-amber-200 text-amber-800 border-2 border-amber-400 shadow-sm',
  },
];

export function MediumFilterChips({
  selectedMediums,
  onToggleMedium,
  counts,
}: MediumFilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {MEDIUM_OPTIONS.map((medium) => {
        const isSelected = selectedMediums.has(medium.value);
        const count = counts[medium.value] ?? 0;

        return (
          <button
            key={medium.value}
            type="button"
            onClick={() => onToggleMedium(medium.value)}
            className={`
              px-2 py-1 rounded-md text-xs font-medium
              transition-all duration-150 hover:opacity-80 cursor-pointer
              ${isSelected ? medium.selectedStyle : medium.unselectedStyle}
            `}
            aria-pressed={isSelected}
            aria-label={`Filter by ${medium.label} consultation, ${count} clients`}
          >
            {medium.label} <span className="ml-0.5 text-[10px]">({count})</span>
          </button>
        );
      })}
    </div>
  );
}
